import React, { createContext, useState, useContext, useEffect } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';
import { getUserPermissions } from '../services/apiUsers';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useLocalStorage('auth', null); // Usar useLocalStorage para auth
  const [permissions, setPermissions] = useState([]); // Estado para los permisos
  const [loadingAuth, setLoadingAuth] = useState(true); // Controla la carga inicial
  const [userEmail, setUserEmail] = useLocalStorage("email",null);

  // Función de login
  const login = async (token) => {
    setAuth({ token }); // Actualiza el auth en el localStorage y el estado
    await loadUserPermissions(token); // Carga los permisos al loguearse
  };

  // Función para cargar permisos
  const loadUserPermissions = async (token) => {
    try {
      const permissionsData = await getUserPermissions(token); // Llama a la API para obtener los permisos
      setPermissions(permissionsData); // Guarda los permisos en el estado
    } catch (error) {
      logout()
      setPermissions({}); // Si ocurre un error, resetea los permisos
    }
  };
  
  // Cargar datos de autenticación desde localStorage al montar el componente
  useEffect(() => {
    // Si ya hay datos en localStorage, establecemos el estado
    if (auth?.token) {
      loadUserPermissions(auth.token); // Carga los permisos si hay un token en el localStorage
    }
    setLoadingAuth(false); // La carga ha finalizado
  }, [auth]);

  // Función de logout
  const logout = () => {
    setLoadingAuth(true); // Mientras se limpia el estado
    setAuth(null); // Borra el auth en el localStorage y el estado
    setPermissions({}); // Borra los permisos
    setLoadingAuth(false); // Termina el proceso de logout
  };

  // Verificar si el usuario está autenticado
  const isAuth = () => {
    return auth && auth.token ? true : false;
  };

  //verificar si tiene permiso
  const hasPermission = ( moduleKey, featureKey, action) => {
    // Buscar el módulo principal o un submódulo en cualquier nivel
    let module = permissions.find(mod => mod.key === moduleKey);

    if (!module) {
        // Si no está en los módulos principales, buscar en los items de cada módulo
        for (const mod of permissions) {
            module = mod.items.find(sub => sub.key === moduleKey);
            if (module) break; // Detener la búsqueda si se encuentra el módulo
        }
    }

    if (!module) return false; // Si no se encontró el módulo, no tiene permiso

    // Verificar si el feature está en el módulo encontrado
    if (module.features[featureKey] && module.features[featureKey].includes(action)) {
        return true;
    }

    return false;
};


  return (
    <AuthContext.Provider value={{
       auth, permissions, setUserEmail, userEmail,
        login, logout, isAuth, loadingAuth , 
        hasPermission}}>
      {children}
    </AuthContext.Provider>
  );
};
